export const PaperData = [
    {
        title:"Effectiveness of Deep Learning and CFA Interpolation Classifiers on Identifying AIGC",
        image:"paper1.png",
        authors:["Michael\xA0Reidy", "Henry\xA0Mallon", "Jiebo\xA0Luo"],
        link:"https://ieeexplore.ieee.org/document/10386096",
        description:["Proposed two novel shallow classifiers for identifying AI-generated content (AIGC) based on the structure of Bayer arrays found in physical cameras.",
                     "Tested our models on a sparse dataset of human faces and a diverse dataset of faces, cats, and dogs to test model generalizability.",
                     "When tested on our diverse dataset, our CNN's achieved an accuracy of 83.15%, and our shallow CFA thresholding models achieved an accuracy of 73.55%."],
        appearsIn:"Published in",
        location:"ieee",
        slug:"identifying-aigc-with-cfa"
    },

    {
        title:"BotOrNot: A Real-Time Bot Detector for X (Formerly Twitter)",
        image:"paper_placeholder.png",
        authors:["Michael\xA0Reidy", "Daniel\xA0Reilly"],
        link:"",
        description:["Created a real-time bot detector for social media using machine learning and html injection.",],
        appearsIn:"Currently in progress",
        location:"",
        slug:"urabot"

    },
    {
        title:"The Mind in the Machine: Imitating the Brain's Functions to Approach AGI",
        image:"paper_placeholder.png",
        authors:["Michael\xA0Reidy"],
        link:"",
        description:[],
        appearsIn:"Currently in progress",
        location:"",
        slug:"mind-in-the-machine"

    },
    {
        title:"Expansions on AIGC Detection",
        image:"paper_placeholder.png",
        authors:["Michael\xA0Reidy"],
        link:"",
        description:[],
        appearsIn:"Currently in progress",
        location:"",
        slug:"zero-shot-aigc"

    },

    {
        title:"More Natural Models of Electoral Control by Partition",
        image:"paper_placeholder.png",
        authors:["M.\xA0Chavrimootoo", "G.\xA0Erdélyi", "E.\xA0Hemaspaandra", "L.\xA0Hemaspaandra", "M.\xA0Kotler-Berkowitz", "Z.\xA0Nie", "M.\xA0Reidy", "E.\xA0Smith"],
        link:"",
        description:["Explores the computational complexity of partitioning candidates and voters to address current gaps in the literature.",],
        appearsIn:"Currently in progress",
        location:"",
        slug:"natural-partition-models"

    },

    {
        title:"On Czerwinski's \"P≠NP relative to a P‑complete oracle\"",
        image:"paper2.png",
        authors:["Michael\xA0C.\xA0Chavrimootoo", "Tran\xA0Duy\xA0Ahn\xA0Le", "Michael\xA0Reidy", "Eliot\xA0J.\xA0Smith"],
        link:"https://arxiv.org/abs/2312.04395",
        description:["A critique of a paper by Reiner Czerwinski that (perhaps unknowingly) claims to give an oracle where P=NP.",
                    "We argue that Czerwinski's Corollary 1 is false through Turing reductions, and thus disprove the author's separation argument.",
                    "We rework some of Czerwinski's original proofs to show that despite their technical flaws, the author's underlying idea cannot prove the separation."],
        appearsIn:"Located in",
        location:"arxiv",
        slug:"czerwinski-critique"

    },
    {
        title:"A Critique of Chen's \"The 2‑MAXSAT Problem Can Be Solved in Polynomial Time\"",
        image:"paper3.png",
        authors:["Tran\xA0Duy\xA0Ahn\xA0Le", "Michael\xA0Reidy", "Eliot\xA0J.\xA0Smith"],
        link:"https://arxiv.org/abs/2404.00006",
        description:["A critique of a paper by Yangjun Chen that claims to give an algorithm to solve an NP‑complete problem (2-MAXSAT) in polynomially-bounded time.",
                    "Provide 4 counterexamples where the author's algorithm fails to give proper solutions, thus proving that their algorithm is invalid.",
                    "Point out concerns that the author's definitions are ambiguous and inconsistent."],
        appearsIn:"Located in",
        location:"arxiv",
        slug:"chen-critique"

    },
    {
        title:"A Critique of Lin's \"On NP versus coNP and Frege Systems\"",
        image:"lin_critique.png",
        authors:["Nicholas\xA0DeJesse", "Spencer\xA0Lyudovyk", "Dhruv\xA0Pai", "Michael\xA0Reidy"],
        link:"https://arxiv.org/abs/2505.05658",
        description:["A critique of a paper by Yanjun Lin that inaccurately claims that NP is closed under infinite union.",],
        appearsIn:"Located in",
        location:"arxiv",
        slug:"lin-critique"

    },

    
]
